import {
  buildRefreshParameters,
  getTabularReducerInfo,
  downloadWithFilters,
} from "./common"
import { apiDelete, apiGet, apiPut } from "../../utils/apiConnector"
import { reportApi, stockApi, purchaseApi } from "../../config/apiUrls"
import { forEachObjIndexed } from "ramda"
import { alertTypes, showMessage } from "../alerts"
import download from "downloadjs"
import { format } from "date-fns"

// Thunk
export function refresh() {
  return (dispatch, getState) => {
    const state = getState()
    const storeId = state.profile.currentStore.id
    dispatch(actions.setLoading(true))
    return apiGet(stockApi, buildRefreshParameters(storeId, state.stock))
      .onOk((res) => {
        if (res.data.response.supplies) {
          dispatch(
            actions.setData(
              res.data.response.supplies.map((s) => ({
                ...s,
                id: s.stockId,
                salePrice: s.salePrice,
                remainder: s.remainder,
                purchases: s.purchases.map((p) => ({
                  ...p,
                  purchasePrice: p.price,
                })),
              })),
            ),
          )
        } else {
          dispatch(actions.setData([]))
        }
        dispatch(actions.setTotalPages(res.data.response.pages))
        dispatch(actions.setTotalCount(res.data.response.count))
      })
      .useDefaultErrorHandlers(dispatch)
      .afterAll(() => {
        dispatch(actions.setLoading(false))
      })
      .startSingle()
  }
}

export function editSupply(editedData) {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    forEachObjIndexed((data, id) => {
      apiPut(stockApi + "/" + id, data)
        .onOk(() => {
          dispatch(
            showMessage("Товар успешно отредактирован", alertTypes.success),
          )
          dispatch(refresh())
          dispatch(actions.edit())
        })
        .useDefaultErrorHandlers(dispatch)
        .start()
    }, editedData)
  }
}

export function editPurchase(editedData) {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    forEachObjIndexed((data, id) => {
      apiPut(purchaseApi + "/" + id, data)
        .onOk(() => {
          dispatch(refresh())
          dispatch(
            showMessage("Товар успешно отредактирован", alertTypes.success),
          )
        })
        .useDefaultErrorHandlers(dispatch)
        .start()
    }, editedData)
  }
}

export function deleteSupply(deleteIds) {
  return (dispatch, getState) => {
    const storeId = getState().profile.currentStore.id
    deleteIds.map((stockId) => {
      apiDelete(stockApi, { stockId, storeId })
        .onOk(() => {
          dispatch(refresh())
          dispatch(showMessage("Товар успешно удален", alertTypes.success))
        })
        .useDefaultErrorHandlers(dispatch)
        .start()
    })
  }
}

export function exportData(callback) {
  return (dispatch, getState) => {
    const state = getState()

    const storeId = state.profile.currentStore.id
    const { id, name } = getState().profile.currentStore
    apiGet(reportApi + "/" + id, downloadWithFilters(storeId, state.stock), {
      responseType: "blob",
      headers: {
        Accept:
          "application/vnd.openxmlformats-officedocument" +
          ".spreadsheetml.sheet",
      },
    })
      .skipValidation()
      .onOk((res) => {
        download(
          res.data,
          name + " (" + format(new Date(), "DD-MM-YYYY") + ").xlsx",
        )
        callback()
      })
      .useDefaultErrorHandlers(dispatch)
      .startSingle()
  }
}

const { actions, reducer, thunks } = getTabularReducerInfo("STOCK", refresh)
export default reducer
export const { openPage, filter, clear, search, sort } = thunks
